import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {gsap} from "utils/gsap";
import {GatsbyImage, StaticImage} from "gatsby-plugin-image";
import {media} from "utils/Media";
import {SignupForm} from "./SignupForm";
import CloseIcon from "images/cross.svg";
import bg from "images/stone-1920x1080.png"

const SignupStyles = styled.section`
  opacity: 0;
  visibility: hidden;
  width: 100%;
  max-width: 100vw;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  display: flex;
  justify-content: center;
  padding: 2rem 0;

  @media ${media.lg} {
    align-items: center;
  }
  
  .wrapper {
    background: url("${bg}") #ffffff center center no-repeat;
    background-size: cover;
    position: relative;
    overflow-y: scroll;
    width: 100%;
    max-width: 500px;
    margin-top: 5rem;
    @media (min-width: 375px) {
      margin-top: 0rem;
      width: 90%;
    }
    @media ${media.lg} {
      display: flex;
      align-items: center;
      justify-items: center;
      height: 90vh;
      max-width: 1147px;
      max-height: 726px;
      min-height: 550px;
      margin: calc(2%) auto;
    }

    .close {
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 40px;
      height: 40px;
      background: ${(props) => props.theme.colors.primary};
      cursor: pointer;
      z-index: 999;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .img {
      display: none;

      @media ${media.lg} {
        display: block;
        max-height: 816px;
        
        width: 100%;
        height: 100%;
        .gatsby-image-wrapper {
          width: 100%;
          height: 100%;
        }
      }
    }

    .form {
      background: none;
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 1.5rem;
      margin: 0 auto;
      position: relative;
      padding-top: 4.5rem;

      @media ${media.lg} {
        margin: 30px auto 0;
        padding: 3.5rem 1.5rem 3.5rem 1.5rem;
        height: calc(100% - 2rem);
        margin: 0 auto;
        max-height: 736px;
        position: initial;
        overflow-y:  auto;
      }

      @media ${media.xl} {
        padding: 2rem 3rem;
      }

      form {
        input[type="text"],
        input[type="email"] {
          // width: 100%;
          // display: block;
          // background: #fff;
          // padding: 1rem 0.85rem;
          // border: none;
          // margin-bottom: 1rem;
          // outline: none;
          // font-family: ${(props) => props.theme.font.family.body};

          &::placeholder {
            font-size: 15px;
            font-family: ${(props) => props.theme.font.family.body};
            color: #686868;
          }

          @media ${media.xl} {
            padding: 1.4rem 1rem;
            &::placeholder {
              font-size: 18px;
            }
          }
        }

        .terms {
          display: flex;
          margin-top: 1rem;
          gap: 1rem;

          input[type="checkbox"] {
            width: 30px;
            height: 30px;
            background-color: none;
            border: white 3px solid;
          }

          p {
            font-family: ${(props) => props.theme.font.family.body};
            line-height: 15px;

            a {
              color: ${(props) => props.theme.colors.secondary};
            }
          }
        }
      }
    }

    @media ${media.lg} {
      //display: grid;
      //grid-template-columns: repeat(2, 1fr);
    }
  }

  @media ${media.xl} {
    .wrapper {
      overflow: hidden !important;
    }
  }

`;

const SignupPopup = ({setCookie, ...props}) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setOpen(true)
        }, 500);

    }, [])

    const popUpRef = useRef();
    const q = gsap.utils.selector(popUpRef);
    const popUpAnimation = useRef();

    useEffect(() => {
        popUpAnimation.current = gsap
            .timeline({duration: 0.5, ease: "power1.out", stagger: 0.5})
            .to(popUpRef.current, {
                opacity: "1",
                visibility: "visible",
                // duration: 0.25,
            })
            .from(q(".wrapper"), {
                y: "-500px",
                opacity: "0",
                // duration: 0.25,
            });

        return () => {
            popUpAnimation.current.kill();
        };
    }, []);

    useEffect(() => {
        if (!open) {
            popUpAnimation.current.reverse();
            document.body.style.overflowY = "auto";
        } else {
            popUpAnimation.current.play();
            document.body.style.overflow = "hidden";
        }
    }, [open]);
    return (
        <SignupStyles ref={popUpRef}>
            <div className="wrapper">
                <div className="form">
                    <div className="close" onClick={() => setOpen(false)}>
                        <img src={CloseIcon} alt=""/>
                    </div>
                    <SignupForm
                        setCookie={setCookie}
                        setOpen={setOpen}
                        simpleWithButton={props.simpleWithButton}
                        blockSignupTitle={props.blockSignupTitle}
                        blockSignupLink={props.blockSignupLink}
                        blockSignupSubtitle={props.blockSignupSubtitle}
                        blockSignupTerms={props.blockSignupTerms}
                    />
                </div>
                <div className="img">
                    <GatsbyImage
                        image={props.blockSignupImage.localFile.childImageSharp.gatsbyImageData}
                        alt="" />
                </div>
            </div>
        </SignupStyles>
    );
};

export default SignupPopup;
